import { cn } from '../../lib/utils';

const variants = {
  default: 'bg-sunken text-muted border-line',
  primary: 'bg-accent-soft text-accent-ink border-transparent',
  success: 'bg-success-soft text-success-ink border-transparent',
  warning: 'bg-warning-soft text-warning-ink border-transparent',
  danger: 'bg-danger-soft text-danger-ink border-transparent',
  // legacy alias
  purple: 'bg-accent-soft text-accent-ink border-transparent',
};

export function Badge({ variant = 'default', className, children }) {
  return (
    <span className={cn(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium border tnum',
      variants[variant] || variants.default,
      className
    )}>
      {children}
    </span>
  );
}
